import { PriviaApi } from './actions';

export const internalApi = {
  priviaApi: new PriviaApi(),
};
